// extracted by mini-css-extract-plugin
module.exports = {"spinner":"FullScreenSpinner_spinner__652mM"};